import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    input: {
        minHeight: 60,
        fontSize: '24px',
        '& input': {
            textAlign: 'center'
        }
    },
    grid: {
    }
}))